const BASE_URL = process.env.REACT_APP_ENV === 'production' ?
    'https://argumentator-api.mndnw.sh' : 'https://argumentator-staging-api.mndnw.sh';
export default BASE_URL;
